import React from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import Chatbot from '../components/chatbot/Chatbot';

const MainLayout: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen min-h-[100dvh] flex-col">
      <a
        href="#main-content"
        className="skip-link"
        onClick={(e) => {
          e.preventDefault();
          const el = document.getElementById('main-content');
          if (!el) return;
          el.scrollIntoView({ behavior: 'auto', block: 'start' });
          requestAnimationFrame(() => el.focus());
        }}
      >
        {t('navigation.skipToContent')}
      </a>
      <Header />
      <div id="main-content" className="flex-grow outline-none" tabIndex={-1}>
        <Outlet />
      </div>
      <Footer />
      <Chatbot />
    </div>
  );
};

export default MainLayout;